import {
  filterCategoryView,
  filterPostView,
  resourcesView
} from "../modules/barba/barba-helpers";
import {
  gsap
} from 'gsap';
import {
  objectOrientation,
  applyGradientLine
} from "./helpers";
import {
  initLottie
} from "../../../includes/lottie/lottie";
import init from "../modules/barba";

export function archiveUi(container) {
  // console.log('archiveUi', container);
  //start vars


  // let resources = container.querySelector('.article__content'); // was using this but better naming conventoin:
  let articleContent = container.querySelector('.article__content'),
    root = document.querySelector(':root'),

    // type of content - used to determine filter type
    type = "archive", //aka initiator
    // container type - used to determineto determine filter
    // containerType = "next", // dentoing that this runs after the barba change ; data.next.container
    containerType = "pre-transform", // dentoing that this runs after the barba change ; data.next.container
    // but actually its not - archiveUI rus on the current container....
    // in a wa all my my jus is initiated on the next containere. Meaning this is really confusing.
    // What OI want it sto decenr between the running of js on the post transforme or the new container.
    /// the post transform would need js to be initiated and then filtered (via the barba transition ui angle)
    // the new archvie would be initiated; but not always filtered (ebecause its might not have a data attribuute if the page has just loaded)
    // this js is added in the barba views - 
    // so what term is better than next and current!? - maybe post transform and new content?
    postTransformContent = container.querySelector('.--post-transform'),
    // existing post data t consider:
    activePost = document.querySelector('body').getAttribute('data-active-post'),
    // body = document.querySelector('body'),
    activeCategory = document.querySelector('body').getAttribute('data-active-category'),
    // this needs to be on the dom - as an attribute or passed into the this function via other others means
    // activeCategory = data.current.container.querySelector("[data-panel-content='resources']").getAttribute('data-category-active'), //

    resourceCategoriesUl = container.querySelector('.archive__body[data-resource-content="archive"] ul'),

    // gsap timeline
    tlArchive = new gsap.timeline(),
    tlArchivePause = true; // this will allow me to pause the timeline when needed

  var activePostExcerptHeight;




  //end vars


  // inititalise lottie animations
  // initLottie(container);
  initLottie(articleContent);


  // resourceCategoriesUl panel orientation - review - the need to have this run on the barbar pre-transform as well...
  // objectOrientation(resourceCategoriesUl)




  // console.log("body", body);
  // console.log("activePost - archiveUi", activePost);
  // console.log("activeCategory - in archiveUi", activeCategory);

  // Resources UI (using articleContent)
  if (articleContent.toString().length > 0) {
    console.log("resources exists in Archive", articleContent);
    resourcesView(articleContent, type); // this is the new content to intialise views
    // console.log("END resources view in Archive");

    // should have altered the view to match the post transform content!? review this...

    // we know the post transform js is triggered via the barba tranistion.
    //the new content js shoudl be fired after the barba transition is complete (i.e here)

    // I need trigger the lcick here mayvbe?


    //filter new content
    if (activePost) {
      console.log("IF activePost in archive-ui.js", activePost);
      filterPostView(activePost, containerType, container, type); // data.next.container
    } else if (activeCategory) {
      //has active category selected (but not post beig clicked - so just filter the category)
      console.log("archive-ui.js - If active category in archive-ui.js", activeCategory);
      filterCategoryView(activeCategory, containerType, container, type);
    } else {
      console.log("archive-ui.js - no activePost - - what else can this be - review and delete if statemenbt else?");
    }

    // height of excerpt:

    if (activePost) {

      // this is the post transform active item
      var activePostItem = container.querySelector('.--post-transform li[data-post-id="' + activePost + '"]');
      //this is the article active item
      var activeItem = container.querySelector('.article__content li[data-post-id="' + activePost + '"]');
      var activePostExcerpt = container.querySelector('.article__content li[data-post-id="' + activePost + '"] .post__excerpt');
      // console.log("activePostEcerpt", activePostExcerpt);

      // activePostExcerpt.style.display = 'block'; //review this - should be hidden by default
      // var activePostExcerptHeight = activePostExcerpt.offsetHeight; // this returns 0 - as it mayveb vecause the items is hidden?
      var activePostExcerptHeight = activePostExcerpt.offsetHeight,
        addedPaddingHeight = container.querySelector('.article__content li[data-post-id="' + activePost + '"] .continue-reading').offsetHeight,
        marginHeight = addedPaddingHeight + activePostExcerptHeight;
        //  activeItemHeight = activeItem.offsetHeight; //active item height - used t calculate the offeset in sidepnales .css
        // getBoundingClientRect()
      // console.log("activePostExcerptHeight", activePostExcerptHeight);
      console.log("addedPaddingtHeight", addedPaddingHeight);
      // console.log("activeItemHeight", activeItemHeight);

      // document.style.addProperty('--active-item-height', activeItemHeight  + "px"); // review this approach - and look at sidepanel css where this value is used.
      // console.log("addedPaddingHeight +", (addedPaddingHeight + activePostExcerptHeight));

// root.style.setProperty('--active-item-height', activeItemHeight  + "px"); // review this approach - and look at sidepanel css where this value is used.

      // console.log("marginHeight", marginHeight);

      tlArchive.fromTo(activePostItem, {
        marginBottom: "0px",
      }, {
        marginBottom: (marginHeight) + "px", // make sure this is not embroilded with transitions issues in the barba js - that all needs to be done before we remove the opacity!
        // opacity: 1, // temp disable - I need to figure out what further needs doing before its a seamless transition from the post transofrm ot the page content - i.e other things not happening yet?!?
        // PointerEvents: "none",
        // backgroundColor: "red",
      }, "0")
    }

  }

  // Post Transform UI Transitions - ensure the above is fully finished before running this - review approach with gsap timelinbe
  if (postTransformContent.toString().length > 0) {
     console.log("HERE ---- postTransformContent exists in Archive", postTransformContent);

    tlArchive.fromTo(postTransformContent, {
        opacity: 1,
      }, {
        opacity: 0, // make sure this is not embroilded with transitions issues in the barba js - that all needs to be done before we remove the opacity!
        // opacity: 1, // temp disable - I need to figure out what further needs doing before its a seamless transition from the post transofrm ot the page content - i.e other things not happening yet?!?
        // PointerEvents: "none",
      }, "0") // review this timing
      .fromTo(articleContent, {
        opacity: 0,
        zIndex: 20,
      }, {
        opacity: 1,
        zIndex: 2,
      }, "<") // review this timing

    postTransformContent.style.pointerEvents = "none";
    // temp meauser - look to apply post loading class or someting
    // and/or z index as well.

    // console.log("Gsap Transition on Archive ccontent containers Ended");


    //after we've finsihed the transforming - maybe I should ensure to celar out all the data attrributes: - Review acrsoss all post barbab instaces
    // document.querySelector('.body').removeAttribute('data-active-post');
    // document.querySelector('.body').removeAttribute('data-active-category');
    // or leave it because they are "active" references to the state of the content - so needs to just be what's there at all times....!?

    ///Gradient line

    /* make sure to revist the whole idea in more deatil befor ei start bodging away
        applyGradientLine(gradientLine, linkTarget);

    */

    let gradientLineContainer = document.querySelector('.line-container');
    let gradientLine = gradientLineContainer.querySelector('.line');

    //  let linkTarget = event.target.getAttribute('data-side-link'),
    let linkTarget = "resources"; // review necisity

    applyGradientLine(gradientLine, linkTarget);
    //  deActivateGradientLine(gradientLine)
    ///END Gradient line  

  }

}


export function archiveOrientation(container) {
  console.log('archiveOrientation', container);
  //start vars


}